export const TRAVEL_CATAGERIES_LIST = "travel_catageries_list"; 
export const TRAVEL_CATAGERIES_LIST_SUCCESSFULL = "travel_catageries_list_successfull";
export const CREATE_TRAVEL_CATAGERIES = "create_travel_catageries";
export const CREATE_TRAVEL_CATAGERIES_SUCCESSFULL = "create_travel_catageries_successfull";
export const UPDATE_TRAVEL_CATAGERIES = "update_travel_catageries";
export const UPDATE_TRAVEL_CATAGERIES_SUCCESSFULL = "update_travel_catageries_successfull";
export const API_ERRORS = 'api_failed';
//CUSTOMER MASTER
export const CREATE_NEW_CUSTOMER_MASTER = "create_new_customer_master";
export const CREATE_NEW_CUSTOMER_MASTER_SUCCESSFULL = "create_new_customer_master_successfull";